
import {  API_ENDPOINTS } from '../constants/constants.js'
import { SingletonSharedData } from '../Singletons/SingletonSharedData.js';

let instance = null;

export class SMResponseHelper {
    constructor() {
        if (!instance) {
            instance = this;
        }
        this.timersSMResponse = [];
        this.sharedData = new SingletonSharedData();
        this.that = null;
        return instance;
    }

    setThat(that){
        if(!this.that){
            this.that = that;
        }
    }
    clearTimer(message){
        let key = message.Subaction ;
        if(this.timersSMResponse[key]){
          console.log("SMResponseReceived CleaningTimer ",key);
          let timer = this.timersSMResponse[key];
          clearTimeout(timer);
          delete this.timersSMResponse[key];
        }
      }

      setTimer(message){        
        let messageKey =  message.Subaction;
        if(message.ExpectsReponse && !this.timersSMResponse[messageKey]){
          console.log("SMResponseExpected SetTimer ", message);
          this.timersSMResponse[messageKey] = setTimeout(()=>this.showNoResponseError(messageKey), this.sharedData.requestTimeout);
        }
      }

      showNoResponseError(key){
        delete this.timersSMResponse[key];
        console.log("SMResponseNotReceived ExecutingNotification ", key);
        this.executeNoSMResponse(key);
      }

      executeNoSMResponse(key){
        switch(key){
          case API_ENDPOINTS.CALL_OUT_CAMPAIGNS:
            break;
          default: break;
        }
      }
}
